import { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { fetchMyEventList } from "../services/adminApiService/venueManagerApi/venueManagerApi";
import PageTitle from "../jsx/layouts/PageTitle";
import EventCard from "./EventCard";
import useSearchValue from "../hooks/useSearchValue";
import { PaginationControl } from "react-bootstrap-pagination-control";
import Form from "react-bootstrap/Form";
import EventFilters from "./EventFilters";

export default function MyEvents() {
  const [data, setData] = useState([]);
  const [dateFilter, setDateFiter] = useState("");
  const [sportFilter, setSportFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState(null);
  const [totalItems, setTotalItems] = useState("");

  const [feeType, setFeeType] = useState("");
  const [clusterFilter, setClusterFilter] = useState("");
  const [venueFilter, setVenueFilter] = useState("");
  const [page, setPage] = useState(1);
  const { searchValue, setSearchValue, debouncedSearchValue } =
    useSearchValue(1000);
  const [appliedFilters, setAppliedFilters] = useState({
    sportFilter: "",
    dateFilter: "",
    statusFilter: null,
    feeType: "",
    clusterFilter: "",
    venueFilter: "",
  });
  const limit = 10;

  useEffect(() => {
    const getMyEvents = async () => {
      const bookings = await fetchMyEventList({
        page,
        limit,
        search: debouncedSearchValue || "",
        ...appliedFilters,
      });

      setData(bookings?.data || []);
      setTotalItems(bookings?.pagination?.total || 0);
    };

    getMyEvents();
  }, [page, debouncedSearchValue, appliedFilters]);

  return (
    <>
      <h1 className="mb-3 fs-2 ">
        <PageTitle motherMenu={"Ticketing"} activeMenu={"My Events"} />
      </h1>
      <div className="assigned-event-header">Assigned Events</div>
      <div className="d-flex align-items-end gap-2 mb-3">
        <Form.Group className="flex-grow-1">
          <Form.Label>Search Events</Form.Label>
          <Form.Control
            type="text"
            placeholder="Search Events..."
            className="p-2"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              setPage(1);
            }}
          />
        </Form.Group>

        <EventFilters
          dateFilter={dateFilter}
          setDateFiter={setDateFiter}
          sportFilter={sportFilter}
          setSportFilter={setSportFilter}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          clusterFilter={clusterFilter}
          setClusterFilter={setClusterFilter}
          venueFilter={venueFilter}
          setVenueFilter={setVenueFilter}
          feeType={feeType}
          setFeeType={setFeeType}
          applyFilters={() => {
            setAppliedFilters({
              sportFilter,
              dateFilter,
              statusFilter,
              feeType,
              clusterFilter,
              venueFilter,
            });

            setPage(1);
          }}
          resetFilters={() => {
            setDateFiter("");
            setSportFilter("");
            setStatusFilter("");
            setClusterFilter("");
            setVenueFilter("");
            setFeeType("")

            setAppliedFilters({
              sportFilter: "",
              dateFilter: "",
              statusFilter: "",
              feeType: "",
              clusterFilter: "",
              venueFilter: "",
            });

            setPage(1);
          }}
        />
      </div>
      <Row className="g-3">
        {data?.map((event) => (
          <Col key={event.id} xs={12} sm={6} md={6} lg={3}>
            <EventCard data={event} />
          </Col>
        ))}
      </Row>

      {data?.length > 0 ? (
        <PaginationControl
          page={page}
          between={4}
          total={totalItems || 250}
          limit={limit}
          changePage={(page) => {
            setPage(page);
          }}
          ellipsis={1}
        />
      ) : (
        <div className="d-flex justify-content-center align-items-center fs-4 p-3">
          No data available
        </div>
      )}
    </>
  );
}
